import { Button, Loading } from "@repo/skapa";
import { t } from "@repo/translation";
import {
  ModalSheet,
  SearchSelect,
  SectionContainer,
  useOrderedCustomerMeetingPoints,
} from "@repo/ui";
import { useState } from "react";

interface CmpSelectionModalProps {
  isOpen: boolean;
  closeModal: () => void;
  selectedCmp?: string;
  onSelect: (cmp?: string) => void;
}

export const CmpSelectionModal = ({
  isOpen,
  closeModal,
  onSelect,
  selectedCmp,
}: CmpSelectionModalProps) => {
  const [localCmp, setLocalCmp] = useState<string | undefined>(selectedCmp);
  const { data: customerMeetingPoints, isLoading } =
    useOrderedCustomerMeetingPoints();

  return (
    <ModalSheet
      title={t("label.cmp")}
      visible={isOpen}
      onClose={closeModal}
      onBack={closeModal}
      footer={
        <Button
          type="primary"
          onClick={() => {
            onSelect(localCmp);
            closeModal();
          }}
          text={t("action.save")}
        />
      }
    >
      {isLoading ? (
        <Loading />
      ) : (
        <SectionContainer>
          <SearchSelect
            localState={localCmp !== undefined ? [localCmp] : []}
            onChange={(_, item) => {
              setLocalCmp(item.value === localCmp ? undefined : item.value);
            }}
            selectionMode="SINGLE"
            values={customerMeetingPoints}
          />
        </SectionContainer>
      )}
    </ModalSheet>
  );
};
